import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useQueryKeySelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { useListingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';
import { useActivePinListingIdSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';
import { type AnalyticsPage, getAnalyticsPage } from '@/packages/utils/analytics';

export const useGetAnalyticsPage = (): AnalyticsPage => {
  const queryClient = useQueryClient();
  const viewMode = useListingLayoutViewModeSelector();
  const activePinId = useActivePinListingIdSelector();
  const searchOffersQueryKey = useQueryKeySelector();

  return useMemo(
    () => getAnalyticsPage({ viewMode, activePinId, searchOffersQueryKey, queryClient }),
    [activePinId, queryClient, searchOffersQueryKey, viewMode],
  );
};
